import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared';
import { Core2Config } from '../../shared';
import { OutboundStockTransferFileImportHelperContainerModel } from '../../../../../../models/aggregates/erp/outbound-stock-transfer-file-import';

@Injectable({
  providedIn: 'root'
})
export class OutboundStockTransferFileImportHelperService extends BaseApiTemplateService<OutboundStockTransferFileImportHelperContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'internal-stock-transfer/import-file-helpers/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'internal-stock-transfer/import-file-helpers/backoffice-ep';
    this.httpClient = http;
  }
}